import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//工单列表查询
export function orderOperaLog(data) {
    return request({
        url: serviceName + `/order-opera-log/page`,
        method: 'post',
        data: data
    })
}
